import { render } from "./new_request.vue?vue&type=template&id=44a937d0"
import script from "./new_request.vue?vue&type=script&lang=js"
export * from "./new_request.vue?vue&type=script&lang=js"

import "./new_request.vue?vue&type=style&index=0&id=44a937d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__